import React from "react";
import Marquee from "react-fast-marquee";
import styled from "styled-components";

// 🎨 이미지 배열
const companyIcons = [
  "/images/company_icon/company/trinity.png",
  "/images/company_icon/company/honeyddanji.png",
  "/images/company_icon/company/TMS.png",
  "/images/company_icon/company/meta94.png",
  "/images/company_icon/company/vibe.png",
  "/images/company_icon/company/ru.png",
  "/images/company_icon/company/cabot.png",
  "/images/company_icon/company/lifton.png.png",
  "/images/company_icon/company/sharp.png",
  "/images/company_icon/company/sym.png",
  "/images/company_icon/company/etoile.png",
  "/images/company_icon/company/onyoo.png",
  "/images/company_icon/company/ino.png",
  "/images/company_icon/company/jungwoo.png",
  "/images/company_icon/company/ete.png",
  "/images/company_icon/company/aging.png",
  "/images/company_icon/company/ssuk.png",
  "/images/company_icon/company/gloty.png",
  "/images/company_icon/company/woori.png",
];

// 🌈 스타일 정의
const CarouselWrapper = styled.div`
  width: 100%;
  padding: 10px 0;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const CarouselItem = styled.div`
  flex: 0 0 auto;
  width: 90px;
  margin: 0 10px;
`;

const Image = styled.img`
  width: 100%;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

// ⚛️ 화살표 함수 형태의 컴포넌트
const MobileCompanyList = () => {
  return (
    <CarouselWrapper>
      <Marquee speed={50} pauseOnHover={true} gradient={false}>
        {companyIcons.map((icon, index) => (
          <CarouselItem key={index}>
            <Image src={icon} alt={`company-${index}`} />
          </CarouselItem>
        ))}
      </Marquee>
    </CarouselWrapper>
  );
};

export default MobileCompanyList;
